import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=36b4b69e&scoped=true&lang=pug&"
import script from "./Tutorial.vue?vue&type=script&lang=js&"
export * from "./Tutorial.vue?vue&type=script&lang=js&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=36b4b69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4b69e",
  null
  
)

export default component.exports